<template>
  <div class="product1">
    <div class="product1-c">
      <div class="product1-info">
        <div class="item" v-for="(item, index) in listType" :key="index" @click="tapList(index)">
          <div class="sitem" v-if="selectIndex == index">
            <img :src="item.max" alt />
            <div class="t">{{item.name}}</div>
            <div class="s">{{item.sec}}</div>
          </div>
          <div class="nitem" v-else>
            <img :src="item.min" alt />
            <div class="t">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="product1-c1">
      <div class="product1-list">
        <div class="h">{{listType[selectIndex].name}}</div>
        <div class="s">{{listType[selectIndex].sec}}</div>
        <div class="list">
          <div class="item" v-for="(item, index) in list" :key="index" @click="tapDetails(item)">
            <div class="t">{{item.productName}}</div>
            <div class="s">{{item.power}}</div>
            <img :src="item.profile" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import min1 from "../../../assets/product/min_1.png";
import min2 from "../../../assets/product/min_2.png";
import min3 from "../../../assets/product/min_3.png";
import max1 from "../../../assets/product/max_1.png";
import max2 from "../../../assets/product/max_2.png";
import max3 from "../../../assets/product/max_3.png";

export default {
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      selectIndex: 0,
      listType: [
        {
          name: "Distributed photovoltaic power station",
          sec:
            "It refers to a small-scale photovoltaic power supply system installed at or near the user's site, while meeting the requirements of both aspects. It is mainly a commercial photovoltaic power station installed on the roof of the industrial and commercial buildings, and the generated electricity is generally consumed by the industrial and commercial enterprises themselves.",
          min: min1,
          max: max1
        },
        {
          name: "Ground photovoltaic power station",
          sec:
            "It refers to a small-scale photovoltaic power supply system installed at or near the user's site, while meeting the requirements of both aspects. It is mainly a commercial photovoltaic power station installed on the roof of the industrial and commercial buildings, and the generated electricity is generally consumed by the industrial and commercial enterprises themselves.",
          min: min2,
          max: max2
        },
        {
          name: "User side energy storage power station",
          sec:
            "It refers to a small-scale photovoltaic power supply system installed at or near the user's site, while meeting the requirements of both aspects. It is mainly a commercial photovoltaic power station installed on the roof of the industrial and commercial buildings, and the generated electricity is generally consumed by the industrial and commercial enterprises themselves.",
          min: min3,
          max: max3
        }
      ]
    };
  },
  created() {},
  methods: {
    tapList(index) {
      this.selectIndex = index;
      this.$emit("tapList", index+1);
    },
    tapDetails(item) {
      this.$router.push("/en/productdetails?id="+item.productId);
    }
  }
};
</script>

<style lang="scss">
div {
  box-sizing: border-box;
}
.product1 {
  .product1-c {
    justify-content: center;
    .product1-info {
      justify-content: space-between;
      align-items: center;
      img {
        background-color: #888;
      }
      .sitem {
        position: relative;
        flex-direction: column;
        justify-content: flex-end;
        color: white;

        img {
          position: absolute;

          z-index: -1;
        }
      }
      .nitem {
        position: relative;

        flex-direction: column;
        justify-content: flex-end;
        color: white;
        .t {
          text-align: center;
        }

        img {
          position: absolute;

          z-index: -1;
        }
      }
    }
  }

  .product1-c1 {
    justify-content: center;
    background-color: #f3f9f9;
    .product1-list {
      .h {
        color: #332c2b;
      }
      .s {
        color: #999999;
      }
      .list {
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .item {
          background-color: white;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          text-align: left;

          .t {
            color: #332c2b;
          }
          .s {
            color: #666666;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .product1 {
    width: 100%;
    .product1-c {
      width: 100%;
      height: 800px;
      display: flex;
      .product1-info {
        width: 1200px;
        padding: 80px 0;
        display: flex;
        .sitem {
          width: 690px;
          height: 600px;
          padding: 48px;
          display: flex;
          .t {
            font-size: 32px;
          }
          .s {
            font-size: 16px;
            margin-top: 15px;
          }
          img {
            top: 0;
            left: 0;
            width: 100%;
            height: 600px;
            z-index: -1;
          }
        }
        .nitem {
          width: 240px;
          height: 600px;
          padding: 48px;
          display: flex;
          .t {
            font-size: 32px;
          }

          img {
            top: 0;
            left: 0;
            width: 100%;
            height: 600px;
          }
        }
      }
    }

    .product1-c1 {
      width: 100%;
      display: flex;
      padding: 64px 0 80px;
      .product1-list {
        width: 1200px;
        .h {
          font-size: 32px;
        }
        .s {
          margin-top: 16px;
          font-size: 16px;
        }
        .list {
          margin-top: 40px;
          display: flex;
          .item {
            width: calc(25% - 10px);
            height: 450px;
            padding: 24px;
			margin-bottom: 16px;
            display: flex;
            .t {
              font-size: 20px;
            }
            .s {
              margin-top: 6px;
              font-size: 16px;
            }
            img {
              margin-top: 90px;
              width: 248px;
              height: 140px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .product1 {
    width: 100%;
    .product1-c {
      width: 100%;
      height: 600px;
      display: flex;
      .product1-info {
        width: 100%;
        padding: 40px 20px;
        display: flex;
        .sitem {
          flex: 3;
          // width: 440px;
          height: 400px;
          padding: 30px;
          display: flex;
          margin-left: 10px;
          .t {
            font-size: 20px;
          }
          .s {
            font-size: 14px;
            margin-top: 12px;
          }
          img {
            top: 0;
            left: 0;
            width: 100%;
            height: 400px;
            z-index: -1;
          }
        }
        .nitem {
          flex: 1;
          margin-left: 10px;
          width: 200px;
          height: 400px;
          padding: 30px;
          display: flex;
          .t {
            font-size: 20px;
          }

          img {
            top: 0;
            left: 0;
            width: 100%;
            height: 400px;
          }
        }
      }
    }

    .product1-c1 {
      width: 100%;
      display: flex;
      padding: 40px 20px 50px;
      .product1-list {
        width: 100%;
        .h {
          font-size: 22px;
        }
        .s {
          margin-top: 12px;
          font-size: 15px;
        }
        .list {
          margin-top: 20px;
          display: flex;
          .item {
            width: calc(25% - 10px);
            height: 360px;
            padding: 18px;
            display: flex;
			margin-bottom: 12px;
            .t {
              font-size: 14px;
            }
            .s {
              margin-top: 6px;
              font-size: 14px;
            }
            img {
              margin-top: 50px;
              width: 80%;
              height: 100px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 880px) {
  .product1 {
    width: 100%;
    .product1-c {
      width: 100%;
      height: 300px;
      display: none;
    }

    .product1-c1 {
      width: 100%;
      display: flex;
      padding: 24px 12px 30px;
      .product1-list {
        width: 100%;
        .h {
          font-size: 17px;
        }
        .s {
          margin-top: 10px;
          font-size: 14px;
        }
        .list {
          width: 100%;
          margin-top: 12px;
          display: flex;
          flex-wrap: wrap;

          .item {
            width: calc(50% - 10px);
            height: 200px;
            padding: 12px;
            display: flex;
            margin-bottom: 12px;
            .t {
              font-size: 13px;
            }
            .s {
              margin-top: 6px;
              font-size: 13px;
            }
            img {
              margin-top: 20px;
              width: 90%;
              height: 70px;
            }
          }
        }
      }
    }
  }
}
</style>
